<script setup lang="ts">
import UserCreateForm from "@/components/user-create-form.vue";
import type { CustomerDTO } from "@/models/dtos/customer-dto";
import { Role } from "@/models/enums/role";
import { RouteName } from "@/router";
import { customersService } from "@/services/customers-service";
import { notificationsService } from "@/services/notifications-service";
import { onBeforeMount, ref, toRefs } from "vue";
import { useRouter } from "vue-router";

const router = useRouter();

const props = defineProps<{ customerNumber: string }>();
const { customerNumber } = toRefs(props);

const pageLoading = ref(false);
const customer = ref<CustomerDTO | undefined>();

onBeforeMount(async () => {
  try {
    pageLoading.value = true;
    customer.value = await customersService.getCustomerByCustomerNumber(
      customerNumber.value!,
    );
  } catch (error) {
    notificationsService.error(error);
  } finally {
    pageLoading.value = false;
  }
});

async function onCreate() {
  await router.push({
    name: RouteName.Customer,
    params: {
      customerNumber: customerNumber.value,
    },
  });
}
</script>

<template>
  <section class="section px-0">
    <p class="title is-4">Skapa kundadministratör för {{ customer?.name }}</p>

    <app-loader v-if="pageLoading"></app-loader>

    <div v-else class="columns">
      <div class="column is-6">
        <user-create-form
          :customer-number="customerNumber"
          :role="Role.CUSTOMER_ADMIN"
          @create="onCreate"
        ></user-create-form>
      </div>
    </div>
  </section>
</template>
